import axios from '@/jslib/axios'

export const getEnquiryList = params => {
  return axios({
    method: 'get',
    url: '/admin/enquiry/all/list',
    params
  })
}

export const getEnquiryDetail = params => {
  return axios({
    method: 'get',
    url: '/admin/enquiry/detail',
    params
  })
}
export const saveEnquiry = data => {
  return axios({
    method: 'post',
    url: '/admin/enquiry/save',
    data
  })
}
export const uploadEnquiryDoc = data => {
  return axios({
    method: 'post',
    url: '/admin/enquiry/internal/file/save',
    data
  })
}
export const delEnquiryDoc = data => {
  return axios({
    method: 'post',
    url: '/admin/enquiry/internal/file/del',
    data
  })
}
export const createEnquiry = data => {
  return axios({
    method: 'post',
    url: '/admin/enquiry/create',
    data
  })
}
export const getEnquiryRemarkList = params => {
  return axios({
    method: 'get',
    url: '/admin/enquiry/remark/list',
    params
  })
}
export const addEnquiryRemark = data => {
  return axios({
    method: 'post',
    url: '/admin/enquiry/remark/add',
    data
  })
}
export const setEnquiryResolved = data => {
  return axios({
    method: 'put',
    url: '/admin/enquiry/resolved/set',
    data
  })
}
export const setEnquirySnooze = data => {
  return axios({
    method: 'put',
    url: '/admin/enquiry/snooze/set',
    data
  })
}
export const setEnquiryUnsnooze = data => {
  return axios({
    method: 'put',
    url: '/admin/enquiry/unsnooze/set',
    data
  })
}
export const bindEnquiryPolicy= data => {
  return axios({
    method: 'post',
    url: '/admin/enquiry/choose/policy',
    data
  })
}
export const bindEnquiryQuote= data => {
  return axios({
    method: 'post',
    url: '/admin/enquiry/choose/quote',
    data
  })
}
export const bindEnquiryCustomer= data => {
  return axios({
    method: 'post',
    url: '/admin/enquiry/choose/customer',
    data
  })
}
export const bindEnquiryReferrer= data => {
  return axios({
    method: 'post',
    url: '/admin/enquiry/choose/referrer',
    data
  })
}
export const bindEnquiryTicket= data => {
  return axios({
    method: 'post',
    url: '/admin/enquiry/related/add',
    data
  })
}
export const setEnquiryCS= data => {
  return axios({
    method: 'put',
    url: '/admin/enquiry/cs/set',
    data
  })
}
export const unableContactEmail= data => {
  return axios({
    method: 'post',
    url: '/admin/enquiry/unable/contact/email',
    data
  })
}
export const setEnquiryAgency= data => {
  return axios({
    method: 'post',
    url: '/admin/enquiry/set/cs/role',
    data
  })
}
export const getEnquiryMessageDetail = params => {
  return axios({
    method: 'get',
    url: '/admin/enquiry/message',
    params
  })
}
export const saveEnquiryMessage = data => {
  return axios({
    method: 'post',
    url: '/admin/enquiry/save/message',
    data
  })
}
export const presignedEnquiry = params => {
  return axios({
    method: 'get',
    url: '/admin/enquiry/prsign/post',
    params
  })
}
export const doneEnquiryUpload = data => {
  return axios({
    method: 'post',
    url: '/admin/enquiry/upload/done',
    data
  })
}
export const getEnquiryTemplateList = params => {
  return axios({
    method: 'get',
    url: '/admin/enquiry/template/list',
    params
  })
}
export const saveEnquiryTemplate = data => {
  return axios({
    method: 'post',
    url: '/admin/enquiry/template/save',
    data
  })
}
export const createEnquiryTemplate = data => {
  return axios({
    method: 'post',
    url: '/admin/enquiry/template/create',
    data
  })
}

export const sortEnquiryTemplate = data => {
  return axios({
    method: 'post',
    url: '/admin/enquiry/template/sort',
    data
  })
}
export const delEnquiryRemark = data => {
  return axios({
    method: 'delete',
    url: '/admin/enquiry/remark/del',
    data
  })
}
